/* @sravni/react-design-system version 0.2.65 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles, safeInvoke } from '@sravni/react-utils';
import '../../Space/index.js';
import { getISODate, getDayFormatted } from '../utils/date.js';
import modules_75b426be from '../styles/Calendar.module.less.js';
import Space from '../../Space/src/Space.js';

var Day = function (props) {
    var date = props.date, active = props.active, disabled = props.disabled, highlighted = props.highlighted, today = props.today, className = props.className, onChange = props.onChange, restProps = __rest(props, ["date", "active", "disabled", "highlighted", "today", "className", "onChange"]);
    var cx = useStyles(modules_75b426be);
    var classNames = cx(className, 'day', {
        today: today,
        active: active,
        disabled: disabled,
        highlighted: highlighted,
    });
    var handleClick = React.useCallback(function () {
        if (disabled) {
            return;
        }
        safeInvoke(onChange, date);
    }, [date, disabled, onChange]);
    return (React.createElement(Space, __assign({ size: 0, align: "center", justify: "center", className: classNames }, restProps, { "data-date": getISODate(date), onClick: handleClick }), getDayFormatted(date)));
};
Day.displayName = 'Day';

export default Day;
//# sourceMappingURL=Day.js.map
